import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { AuthenticationService } from '@mobileia/authentication';
import { UserService } from 'src/app/services/user.service';
import { AlertService } from 'src/app/services/alert.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('inputEmail', { static: false }) private inputEmail: SwalComponent;
  @ViewChild('loginNewError', { static: false }) private loginNewError: SwalComponent;
  @ViewChild('inputDNI') inputDNI: ElementRef ;
  @ViewChild('inputPass') inputPass: ElementRef ;

  documentInput = '';
  emailInput = '';
  passInput = '';
  hide = true;
  step = 0;
  isSending = false;
  isVisible = false;

  constructor(
    protected authService: AuthenticationService,
    protected userService: UserService,
    protected alertService: AlertService,
    protected navigator: Router
  ) { }

  ngOnInit() {

  }

  ngAfterContentChecked() {
    if(this.inputDNI != undefined){
      if(!this.inputEmail.swalVisible){
      this.inputDNI.nativeElement.focus();
      }
    }
    if(this.inputPass != undefined){
      if(!this.inputEmail.swalVisible){
      this.inputPass.nativeElement.focus();
      }
    }
  }

  saveEmail() {
    this.isSending = true;
    this.userService.saveEmail(this.documentInput, this.emailInput).toPromise()
    .then(data => {
      this.isSending = false;
      if (!data.success) {
        this.alertService.showError('Error', 'Se ha producido un error, vuelva a intentarlo');
        return;
      }

      this.alertService.showSuccess('Enviada!', 'La contraseña está llegando a su dirección de correo ingresada.');
      this.step = 2;
    })
    .catch(error => {
      this.isSending = false;
    });
  }

  verifyDocument() {
    this.isSending = true;
    this.userService.validDocument(this.documentInput).toPromise()
    .then(data => {
      this.isSending = false;
      if (!data.success) {
        this.loginNewError.fire();
        return;
      }

      // Usuario no tiene email cargado
      if (data.response.process == 1) {
        this.step = 1;
      } else {
        this.step = 2;
      }

    })
    .catch(error => {
      this.isSending = false;
    });
  }

  onContact() {
    window.location.href = 'http://amvtasociate.ddns.net';
  }

  onLogin() {
    if (this.isSending) {
      return;
    }

    if (this.step == 0) {
      this.verifyDocument();
    } else if (this.step == 1) {
      this.saveEmail();
    } else if (this.step == 2) {
      this.userService.loginInternal(this.documentInput, this.passInput).toPromise().then(data => {
        if (data.success) {
          this.step = 0;
          //window.location.reload();
        } else {
          this.alertService.showError('Error', data.error.message);
        }
      });
    }
  }

  onClickRecovery() {
    this.inputEmail.fire();
    return false;
  }

  onRecovery(email) {
    this.userService.recoveryPassWithEmail(email).toPromise().then(data => {
      if(!data.success){
        this.alertService.showError('Error', 'Este email no se encuentra registrado!');
        return;
      }
      this.alertService.showSuccess('Recuperación!', 'Te hemos enviado tu contraseña al correo electronico.');
    });

    return false;
  }

  onClickBack() {
    this.step = 0;
    return false;
  }

}
